import React from "react";
import ProductPage from "../components/Home/Products/ProductPage";
import Footer from "../components/Home/Footer/Footer";
import NewArrival from "../components/Home/NewArrival/NewArrival";

const NewArriavals = () => {
  return <div>
    <NewArrival />
    <ProductPage />
    <Footer />
  </div>;
};

export default NewArriavals;
